/* GOTRAX header – menus, drawer, search, smart sticky, cart count. No dependencies. */
(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var wrap = root.closest('.gtx-header-section') || root;
    var scrim = document.querySelector('[data-gxh-scrim]');
    var drawer = document.querySelector('[data-gxh-drawer]');
    var openId = null, t = null;
    var desktop = window.matchMedia('(min-width: 1001px)');
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-gxh-mega]'));

    function loadImgs(panel) {
      panel.querySelectorAll('img[data-gxh-src]').forEach(function (img) { img.src = img.getAttribute('data-gxh-src'); img.removeAttribute('data-gxh-src'); });
    }
    function show(id) {
      btns.forEach(function (b) {
        var on = b.getAttribute('aria-controls') === id;
        b.setAttribute('aria-expanded', on);
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) { p.classList.toggle('is-open', on); if (on) loadImgs(p); }
      });
      openId = id;
      if (scrim) scrim.classList.toggle('is-on', !!id);
    }
    var hoverAt = 0;
    btns.forEach(function (b) {
      b.addEventListener('mouseenter', function () { if (!desktop.matches) return; hoverAt = Date.now(); clearTimeout(t); t = setTimeout(function () { show(b.getAttribute('aria-controls')); }, 120); });
      b.addEventListener('click', function () {
        var id = b.getAttribute('aria-controls');
        clearTimeout(t);
        /* a mouse click right after hovering should open, not close */
        if (Date.now() - hoverAt < 600) { show(id); return; }
        show(openId === id ? null : id);
      });
    });
    root.querySelectorAll('.gxh__nav > li > a').forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (!desktop.matches) return; clearTimeout(t); t = setTimeout(function () { show(null); }, 120); });
    });
    root.addEventListener('mouseleave', function () { if (!desktop.matches) return; clearTimeout(t); t = setTimeout(function () { show(null); }, 220); });
    root.querySelectorAll('.gxh__mega').forEach(function (m) { m.addEventListener('mouseenter', function () { clearTimeout(t); }); });

    /* search: use the theme's search drawer if it exists, otherwise our own bar */
    var own = root.querySelector('[data-gxh-own-search]');
    root.querySelector('[data-gxh-search]').addEventListener('click', function (e) {
      if (!desktop.matches && drawer) { /* phones: use the menu's search box */
        e.preventDefault(); e.stopPropagation(); openDrawer();
        setTimeout(function () { var i = drawer.querySelector('[data-gxh-drawer-search]'); if (i) i.focus(); }, 320);
        return;
      }
      if (document.getElementById('search-drawer')) return; /* theme opens its drawer */
      e.preventDefault(); show(null); own.classList.add('is-open');
      setTimeout(function () { own.querySelector('input').focus(); }, 50);
    });
    var cs = root.querySelector('[data-gxh-close-search]');
    if (cs) cs.addEventListener('click', function () { own.classList.remove('is-open'); });

    /* phone drawer */
    var opener = root.querySelector('[data-gxh-open-drawer]');
    function openDrawer() { drawer.classList.add('is-open'); scrim.classList.add('is-on'); opener.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; setTimeout(function () { var c = drawer.querySelector('[data-gxh-close-drawer]'); if (c) c.focus(); }, 60); }
    function closeDrawer() { if (!drawer.classList.contains('is-open')) return; drawer.classList.remove('is-open'); scrim.classList.remove('is-on'); opener.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; opener.focus(); }
    if (opener && drawer) {
      opener.addEventListener('click', openDrawer);
      drawer.querySelector('[data-gxh-close-drawer]').addEventListener('click', closeDrawer);
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = drawer.querySelectorAll('a[href], button, input, summary');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    if (scrim) scrim.addEventListener('click', function () { show(null); closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { show(null); closeDrawer(); if (own) own.classList.remove('is-open'); } });
    desktop.addEventListener && desktop.addEventListener('change', function () { show(null); closeDrawer(); });

    /* smart sticky + shared header height for other sticky bars */
    var smart = root.getAttribute('data-smart') === 'true';
    var last = window.pageYOffset, ticking = false, hidden = false;
    function setVar() {
      var h = hidden ? 0 : wrap.offsetHeight;
      var de = document.documentElement.style;
      de.setProperty('--gtx-header-h', h + 'px');
      de.setProperty('--header-height', wrap.offsetHeight + 'px');
      de.setProperty('--sticky-area-height', h + 'px');
    }
    function onScroll() {
      var y = window.pageYOffset;
      if (smart && !openId && !(drawer && drawer.classList.contains('is-open')) && !(own && own.classList.contains('is-open'))) {
        var hide = y > last && y > wrap.offsetHeight + 80;
        if (hide !== hidden) { hidden = hide; wrap.classList.toggle('is-hidden', hidden); setVar(); }
        if (y <= 0 && hidden) { hidden = false; wrap.classList.remove('is-hidden'); setVar(); }
      }
      last = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    window.addEventListener('resize', setVar);
    setVar();

    /* cart count: follow the theme's cart events, fall back to /cart.js */
    var countEl = root.querySelector('[data-gxh-count]');
    function setCount(n) { if (!countEl) return; countEl.textContent = n; countEl.hidden = !n; }
    function refresh(e) {
      var c = e && e.detail && (e.detail.cart || (e.detail.cartData));
      if (c && typeof c.item_count === 'number') { setCount(c.item_count); return; }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    }
    ['cart:change', 'cart:refresh', 'cart:updated', 'cart:update'].forEach(function (ev) { document.addEventListener(ev, refresh); document.documentElement.addEventListener(ev, refresh); });
  }
  function boot() { document.querySelectorAll('[data-gxh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-gxh]'); if (r) init(r); });
})();
/* Tracking labels (data-gox) so existing click tracking keeps working with the GTX header */
(function () {
  function slug(t) { return String(t || '').trim().toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function tag(el, cat, label) { if (el && !el.hasAttribute('data-gox-category')) { el.setAttribute('data-gox-category', cat); el.setAttribute('data-gox-label', label); } }
  function run() {
    document.querySelectorAll('.gxh a[aria-controls="cart-drawer"], .gxh a[href$="/cart"]').forEach(function (a) { tag(a, 'cart-drawer', 'open-cart-drawer'); });
    document.querySelectorAll('[data-gxh-open-drawer]').forEach(function (b) { tag(b, 'hamburger-menu', 'null'); });
    document.querySelectorAll('[data-gxh-search]').forEach(function (b) { tag(b, 'search', 'search-usage'); });
    document.querySelectorAll('.gxh__nav .gxh__l').forEach(function (l) { tag(l, 'nav-click', slug(l.textContent)); });
    document.querySelectorAll('.gxh__mega a, .gxh-drawer a').forEach(function (a) { tag(a, 'nav-click', slug(a.textContent).slice(0, 40)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();